import { useState } from "react";
import { observer } from "mobx-react";
import Modal from 'react-bootstrap/Modal';
import productosStore from '../stores/ProductosStore';
import globals from '../globals';
import Loading from "./Loading";

export const Download = (props) => {
    const { id, filename, extension } = props;
    const [loading, setLoading] = useState(false);
    const [fecha, setFecha] = useState('');

    const getDate = (date) => {
        const url = globals.OPEN + '/api/archivos/updated/' + id;
        fetch(url)
            .then(response => response.text())
            .then(txt => {
                setFecha(txt);
            }).catch((err) => {
                console.error(err);
            });
    }
    if (!fecha) getDate(id);

    const dwnFile = (date) => {
        const url = globals.OPEN + '/cdn/archivos/' + id + '.' + extension + '?' + date;
        setLoading(true);
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                //const d = new Date();
                //const date = `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = filename + '_' + date + '.' + extension;
                link.click();
                setLoading(false);
            }).catch((err) => {
            setLoading(false);
            console.error(err);
        });
    }
    const dwn = () => {
        const url = globals.OPEN + '/api/archivos/updated/' + id;
        fetch(url)
            .then(response =>
                response.text()
                    .then(response => {
                        const fecha = response.split(' ')[0]
                            .replaceAll(' ', '_')
                            .replaceAll('/', '-');
                        dwnFile(fecha);
                    })
            )
    }
    return (
        <a type="submit" className="" onClick={() => dwn()} style={{textAlign: 'center'}}>
            {loading && <Loading size={'27'} /> }
            {!loading && extension==='xls' && <i className="fa-solid fa-file-excel" style={{fontSize: '27px'}}></i> }
            {!loading && extension==='pdf' && <i className="fa-solid fa-file-pdf" style={{fontSize: '27px'}}></i> }
            <div style={{
                fontSize: '0.7em',
                lineHeight: '10px'
            }}> {fecha} </div>
        </a>
    )
}

function ModalDownload() {
	return (
        <Modal
            show={productosStore.showDownloadModal}
            onHide={() => productosStore.setShowDownloadModal(false)}
            backdrop={'static'}
            keyboard={false}
            className="descarga-catalogo"
        >
            <Modal.Header>
                <h4 className="modal-title " id="">DESCARGAR EL CATALOGO DE PRODUCTOS</h4>
                <button type="button" className="btn-close" aria-label="Close" onClick={() =>
                    productosStore.setShowDownloadModal(false)
                }></button>
            </Modal.Header>
            <div className="modal-body">
                <div className="row">
                    <div className="col-12" style={{textAlign: 'center'}}>
                        <h4>DISTRICENTRO FERRETERA</h4>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <table className={'table'}>
                            <tr>
                                <td> CATALOGO DE PRODUCTOS </td>
                                <td className={'file'}>
                                    <Download
                                        id={3}
                                        url='/cdn/archivos/3.xls'
                                        filename='CatalogoDistricentro'
                                        extension='xls'
                                    />
                                </td>
                                <td className={'file'}>
                                    <Download
                                        id={4}
                                        url='/cdn/archivos/4.pdf'
                                        filename='CatalogoDistricentro'
                                        extension='pdf'
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td> ULTIMAS MODIFICACIONES </td>
                                <td className={'file'}>
                                    <Download
                                        id={11}
                                        url='/cdn/archivos/11.xls'
                                        filename='ModificacionesDistricentro'
                                        extension='xls'
                                    />
                                </td>
                                <td className={'file'}>
                                    <Download
                                        id={12}
                                        url='/cdn/archivos/12.pdf'
                                        filename='ModificacionesDistricentro'
                                        extension='pdf'
                                    />
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-12" style={{textAlign: 'center'}}>
                        <h4>LEONARDO</h4>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <table className={'table'}>
                            <tr>
                                <td> CATALOGO DE PRODUCTOS </td>
                                <td className={'file'}>
                                    <Download
                                        id={2}
                                        url='/cdn/archivos/2.xls'
                                        filename='CatalogoLeonardo'
                                        extension='xls'
                                    />
                                </td>
                                <td className={'file'}>
                                    <Download
                                        id={1}
                                        url='/cdn/archivos/1.pdf'
                                        filename='CatalogoLeonardo'
                                        extension='pdf'
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td> CATALOGO DE PRODUCTOS CON FOTOS </td>
                                <td className={'file'}>
                                    <Download
                                        id={14}
                                        url='/cdn/archivos/14.xls'
                                        filename='CatalogoLeonardoConFotos'
                                        extension='xls'
                                    />
                                </td>
                                <td className={'file'}> </td>
                            </tr>
                            <tr>
                                <td> ULTIMAS MODIFICACIONES </td>
                                <td className={'file'}>
                                    <Download
                                        id={13}
                                        url='/cdn/archivos/13.xls'
                                        filename='ModificacionesLeonardo'
                                        extension='xls'
                                    />
                                </td>
                                <td className={'file'}> </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </Modal>
	);
}
export default observer(ModalDownload);
